var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('number-card',{attrs:{"secondary":"","bold":"","amount":_vm.toPlanAuditsAmount,"title":_vm.$it('dashboard.card.audits-to-plan.title', 'Audits To Plan')}})}
var staticRenderFns = []

export { render, staticRenderFns }